var React = require('react');

function TickCircleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M10.7344449,3.61094259 L6.65482581,9.6191089 L4.72067897,8.33364515 L3.61364515,9.99932103 L6.37240902,11.8328379 C6.82914965,12.1363948 7.44515954,12.0154581 7.75323218,11.5617512 L12.3890574,4.73444491 L10.7344449,3.61094259 Z"}));
}

TickCircleInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = TickCircleInline;

TickCircleInline.default = TickCircleInline;
